import ReducerBuilder from 'classes/ReducerBuilder';
import {Types} from './actions';

const initialState = Object.freeze({
  isOpen: false,
  currentWinnerId: null,
  currentPrizeHistory: [],
  requestSuccess: false
});

export default ReducerBuilder.make(initialState)
  .forType(Types.OPEN_WINNER_DETAIL_MODAL)
  .reduce((state, action) => {
    state.isOpen = true;
    state.requestSuccess = false;
    state.currentWinnerId = action.winnerId;
  })
  .forType(Types.REQUEST_PRIZE_HISTORY).reduce((state, action) => {/* noop */})
  .forType('RECEIVED_ALL_RESOURCES_PRIZEENTRY')
  .reduce((state, action) => {
    if (state.currentWinnerId) {
      state.requestSuccess = true;
      state.currentPrizeHistory = action.resources;
    }
  })
  .forType(Types.CLOSE_WINNER_DETAIL_MODAL)
  .reduce((state, action) => {
    state.isOpen = false;
    state.currentWinnerId = null;
    state.currentPrizeHistory = [];
  })
  .build();



// WEBPACK FOOTER //
// ./public/components/WinnerDetailModal/reducer.js